import { HistoricRepository } from '../../repositories/HistoricRepository';
import { UseCase } from '../UseCase';
import { Sell } from '../../models/Sell';
import { QueryByType } from '../../constants/QueryByType';

export class GetHistoricMovementsByDateUseCase implements UseCase<GetHistoricMovementsByDateRequestDto, Sell[]>{

    constructor(
        private historicRepo: HistoricRepository
    ) { }

    execute(t: GetHistoricMovementsByDateRequestDto): Promise<Sell[]> {
        return this.historicRepo.getHistoricMovementsByDate(t.queryBy, t.date, t.page, t.all);
    }

}

export class GetHistoricMovementsByDateRequestDto {
    constructor(
        public queryBy: QueryByType,
        public date: string,
        public page: number,
        public all:boolean = false
    ) { }
}